import { compose } from 'recompose';
import connectToStores from 'vendor/cnpm/fluxible.v0-4/addons/connectToStores';

import type { ActionContext } from 'js/lib/ActionContext';

import RolesCheckboxGroup from '../RolesCheckboxGroup';
import type { ObjectId, StaffManagementStoreV2 as StaffManagementStoreClass, StaffMembershipType } from '../store';
import { actions } from '../store';
import withFluxibleContextAsProps from '../withFluxibleContextAsProps';

type Props = {
  /** Id of entity to load data from. */
  fromId?: ObjectId;
  onChange(options: Array<string>): void;
  action: string;
  /** One of the types supported by the staff-membershp component. Modifies messaging shown. */
  type?: keyof typeof StaffMembershipType;
  value?: Array<string>;
};

export const onChange = (executeAction: $TSFixMe) => (values: Array<string>) => {
  // Values map to role ids.
  executeAction(actions.editFlow.roles, values);
};

export const storeConnector = (
  { StaffManagementStoreV2 }: { StaffManagementStoreV2: StaffManagementStoreClass },
  { executeAction }: $TSFixMe
) => {
  const editFlowState = StaffManagementStoreV2.get().ui?.editFlow;
  return {
    onChange: onChange(executeAction),
    value: editFlowState?.roles,
  };
};

export default compose<Props, Props>(
  withFluxibleContextAsProps(),
  connectToStores<Props, Props & ActionContext>(['StaffManagementStoreV2'], storeConnector)
)(RolesCheckboxGroup);
